import React from 'react';
import { Form } from 'react-bootstrap';
import AppModal from '../common/AppModal';

const BillingNoteModal = ({ show, onHide, values, onValuesChange, onSubmit, submitting }) => {
  return (
    <AppModal
      show={show}
      onHide={onHide}
      onSubmit={onSubmit}
      heading="Add Billing Notes"
      submitting={submitting}
      submitDisabled={!values?.text?.trim()}
      submitLabel="Save"
    >
      <Form.Control
        as="textarea"
        rows={4}
        className="app-modal-notes-input mt-0 midFont"
        value={values?.text || ''}
        onChange={e => onValuesChange('text', e.target.value)}
        placeholder="Add billing note..."
        autoFocus
        disabled={submitting}
      />
    </AppModal>
  );
};

export default BillingNoteModal;
